import { dispatch, mutate, receive } from "./api.service";
import jwtService from "./jwt.service";

const base = "/mentor";

export const registerMentor = (data) => dispatch(data, `${base}/register`);

export const updateMentorProfile = (data) => mutate(data, `${base}`);
export const getAllMentors = () => receive(`/mentors/accepted`);
